// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lGvj","col":"styles_col__2Ebn9","actions":"styles_actions__3xErZ","conflict":"styles_conflict__2gM3h"};